export var convertToDeposit = function (dto) {
    return {
        id: dto.id,
        uuid: dto.uuid,
        amount: dto.amount,
        appointmentId: dto.appointment_id,
        clientId: dto.customer_id,
        invoiceId: dto.invoice_id,
        paid: dto.paid,
    };
};
